module.exports = __webpack_public_path__ + "img/form5.726276da.jpg";